export const filterTree = (node, query) => {
    const q = query.toLowerCase();
    const matches = node.name.toLowerCase().includes(q) ||
        node.uid.toString().toLowerCase().includes(q);
    const filteredChildren = [];
    for (const child of node.childNodes) {
        const result = filterTree(child, query);
        if (result !== undefined) {
            filteredChildren.push(result);
        }
    }
    if (!matches && filteredChildren.length === 0) {
        return undefined;
    }
    return Object.assign(Object.assign({}, node), { childNodes: filteredChildren, 
        // auto-expand matching branches
        expanded: query.length > 0 ? true : node.expanded });
};
